import { defineComponent as r, createBlock as p, openBlock as a, normalizeProps as n, guardReactiveProps as l, withCtx as s, renderSlot as m, createElementVNode as u } from "vue";
import d from "../CdrIcon.vue.mjs";
const f = /* @__PURE__ */ r({
  name: "PlusLg",
  __name: "plus-lg",
  props: {
    props: {
      type: Object
    }
  },
  setup(t) {
    return (o, e) => (a(), p(d, n(l(t.props)), {
      default: s(() => [m(o.$slots, "default"), e[0] || (e[0] = u("path", {
        role: "presentation",
        d: "M11 11H6a1 1 0 000 2h5v5a1 1 0 002 0v-5h5a1 1 0 000-2h-5V6a1 1 0 00-2 0v5z"
      }, null, -1))]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
